import React, { useRef, useState, useEffect } from 'react';
import { Button, Icon } from '.';
import ReactTooltip from 'react-tooltip';

export function NumberPicker({
  value,
  onChange,
  step = 1,
  min = undefined,
  max = undefined,
  placeholder = '',
  disabled = false,
  className
}) {
  const [error, setError] = useState(false);
  const inputRef = useRef();
  ReactTooltip.rebuild();
  const tooltipID = 'chronosMarkerTemplateForm';
  const addStepToValue = () => {
    if (disabled) {
      return;
    }
    let newValue = parseFloat(value ? value : 0) + step;
    if (isNaN(newValue)) {
      setError('The value entered is not a valid number');
      return;
    }
    if (max) {
      if (newValue <= max) {
        onChange(newValue);
      }
      //handle error
      return;
    }
    onChange(newValue);
  };

  const subtractStepFromValue = () => {
    if (disabled) {
      return;
    }
    let newValue = parseFloat(value ? value : 0) - step;
    if (isNaN(newValue)) {
      setError('The value entered is not a valid number');
      return;
    }
    if (min) {
      if (newValue >= min) {
        onChange(newValue);
      }
      //handle error
      return;
    }
    onChange(newValue);
  };

  const handleInputChange = (ev) => {
    if (disabled) {
      return;
    }
    if (inputRef && inputRef.current) {
      // let { value } = inputRef.current;
      let { value: inputValue } = ev.currentTarget;
      let parsedValue = parseFloat(inputValue);
      if (!isNaN(parsedValue)) {
        onChange(parsedValue);
        setError(false);
      } else {
        onChange(inputValue);
        setError(`"${inputValue}" is invalid. Please enter a valid number.`);
      }
    }
  };

  const handleBlur = (ev) => {
    if (ev.currentTarget.value === '') {
      if (min) onChange(min);
      else onChange(0);
    } else if (isNaN(parseFloat(ev.currentTarget.value))) {
      if (min) onChange(min);
      else onChange(0);
    }
  };

  useEffect(() => {
    if (value && value.length) {
      const parsedValue = parseFloat(value.slice());

      if (isNaN(parsedValue)) {
        console.log('NAN');
        setError('The value entered is not a valid number.');
        return;
      }

      if (max) {
        if (parsedValue > max) {
          console.log('max');
          setError('The value entered exceeds the maximum allowed.');
          return;
        }
      }

      if (min) {
        if (parsedValue < min) {
          console.log('min');
          setError('The value entered is lower than the minimum allowed.');
          return;
        }
      }
    }
    setError(false);
  }, [value]);

  return (
    <div
      className={[
        'chronos-number-input-component',
        error ? 'hasError' : '',
      ].join(' ')}
      style={{ width: '100%' }}
    >
      <div className="chronos-number-spinner">
        <Button onClick={subtractStepFromValue} size="xs" disabled={disabled}>
          <Icon
            icon="far fa-minus fa-fw"
            data-tip={`Decrease by ${step}`}
            data-for={tooltipID}
          />
        </Button>
        <div className="chronos-number-spinner-value">
          <input
            type="text"
            value={value}
            onChange={handleInputChange}
            onBlur={handleBlur}
            ref={inputRef}
            placeholder={placeholder}
            disabled={disabled}
            style={{width: '100%', display: 'block'}}
          />
        </div>

        <Button onClick={addStepToValue} size="xs" disabled={disabled}>
          <Icon
            icon="far fa-plus fa-fw"
            data-tip={`Increase by ${step}`}
            data-for={tooltipID}
          />
        </Button>
      </div>
      {error && <div className="chronos-number-input-error">{error}</div>}

      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
}
